import { render, staticRenderFns } from "./cardetect.vue?vue&type=template&id=93431cac&scoped=true&"
import script from "./cardetect.vue?vue&type=script&lang=js&"
export * from "./cardetect.vue?vue&type=script&lang=js&"
import style0 from "./cardetect.vue?vue&type=style&index=0&id=93431cac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93431cac",
  null
  
)

export default component.exports